import { Inject, Injectable } from '@angular/core';
import { Observable, of } from "rxjs";
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EnumInjectionTokens, EnumMessageCenterFoldersType } from '../../constants';
import { IEnvironment, IMessageCenterInboxCounts } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class McService {
  constructor(
    private httpClient: HttpClient,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  get controller() { return `${this.environment.base.apiUrl}/MessageCenter`; }

  unreadCount(folder: EnumMessageCenterFoldersType): Observable<number> {
    const url = `${this.controller}/unreadCount`;

    return this.httpClient.get<IMessageCenterInboxCounts[]>(url).pipe(
      map(msgs => msgs?.find(x => x?.name === folder)),
      map(x => x?.actionItemsCount || 0),
      catchError((val: HttpErrorResponse) => {
        console.log(`unable to fetch 'messageCenterUnreadMessages': ${val.message}`);
        return of(0);
      })
    );
  }
}
